import React from "react";
import GrComponentFactory from "../gr_component_factory";

const svgNodeType = React.PropTypes.shape({
  tag: React.PropTypes.string.isRequired,
  attributes: React.PropTypes.object,
  children: React.PropTypes.array,
});

const iconPresentationType = React.PropTypes.shape({
  className: React.PropTypes.string.isRequired,
  containerClassName: React.PropTypes.string,
  css: React.PropTypes.string,
  icons: React.PropTypes.objectOf(svgNodeType).isRequired,
});

const controlTextType = React.PropTypes.shape({
  placeholder: React.PropTypes.string,
  accessibleLabel: React.PropTypes.string,
});

const searchFormTextType = React.PropTypes.shape({
  heading: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  accessibleLabel: React.PropTypes.string,
});

const textPresentationType = React.PropTypes.shape({
  headerSearch: controlTextType,
  searchForm: searchFormTextType,
});

export const searchExperiencePresentationType = React.PropTypes.shape({
  icon: iconPresentationType,
  text: textPresentationType,
});

const ALLOWED_SVG_ATTRIBUTES = {
  svg: ["xmlns", "viewBox", "aria-hidden", "focusable", "data-placement"],
  defs: [],
  linearGradient: ["id", "x1", "y1", "x2", "y2", "gradientUnits"],
  stop: ["offset", "stopColor"],
  path: ["className", "d", "fill", "fillRule", "clipRule"],
  g: ["className", "transform"],
};

export const renderSearchSvgNode = (node, key = "search-svg-root") => {
  const allowedAttributes = node &&
    Object.prototype.hasOwnProperty.call(ALLOWED_SVG_ATTRIBUTES, node.tag) ?
    ALLOWED_SVG_ATTRIBUTES[node.tag] :
    null;
  if (!allowedAttributes) {
    return null;
  }

  const rawAttributes = node.attributes &&
    typeof node.attributes === "object" &&
    !Array.isArray(node.attributes) ?
    node.attributes :
    {};
  const attributes = Object.keys(rawAttributes).reduce(
    (safeAttributes, attribute) => {
      const value = rawAttributes[attribute];
      if (
        allowedAttributes.includes(attribute) &&
        (typeof value === "string" || typeof value === "number")
      ) {
        safeAttributes[attribute] = value;
      }
      return safeAttributes;
    },
    {}
  );
  const children = (Array.isArray(node.children) ? node.children : []).map(
    (child, index) => renderSearchSvgNode(child, `${key}-${index}`)
  );

  return React.createElement(
    node.tag,
    Object.assign({ key }, attributes),
    ...children
  );
};

export const SearchExperiencePresentationStyles = GrComponentFactory.createClass({
  displayName: "SearchExperiencePresentationStyles",

  propTypes: {
    presentation: searchExperiencePresentationType,
  },

  render() {
    const css = this.props.presentation &&
      this.props.presentation.icon &&
      this.props.presentation.icon.css;
    if (!css) {
      return null;
    }

    return <style data-search-experience-presentation>{css}</style>;
  },
});

export default GrComponentFactory.createClass({
  displayName: "SearchExperienceIcon",

  propTypes: {
    placement: React.PropTypes.string.isRequired,
    presentation: searchExperiencePresentationType,
  },

  render() {
    const presentation = this.props.presentation;
    const iconPresentation = presentation && presentation.icon;
    const icon = iconPresentation &&
      iconPresentation.icons &&
      iconPresentation.icons[this.props.placement];
    if (!icon) {
      return null;
    }

    return <span className={iconPresentation.className} aria-hidden="true">
      {renderSearchSvgNode(icon)}
    </span>;
  },
});
